import { render } from "./LotStockDetails.vue?vue&type=template&id=03ecd523"
import script from "./LotStockDetails.vue?vue&type=script&lang=js"
export * from "./LotStockDetails.vue?vue&type=script&lang=js"
script.render = render

export default script